import React, { useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";

function Breadcrumb() {
  const [copied, setCopied] = React.useState(false);
  const [isTrueVal, setIsTrueVal] = React.useState([0,false]);
  const [inputFields, setInputFields] = useState([{
    type: "ListItem",
    position: 1,
    name: '',
    item: '',
  }]);

  const urlPatternValidation = URL => {
    const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
    return regex.test(URL);
  };
  const handleChange1 = (index, evnt) => {
    const { name, value } = evnt.target;
    if (name === 'item' && value.length > 0) {
      let isTrueValss = !value || urlPatternValidation(value);
      if (isTrueValss === false) {
        setIsTrueVal([index, true]);
      }
      else {
        setIsTrueVal([index, false]);
      }
    }
    const list = [...inputFields];
    list[index][name] = value;
    setInputFields(list);
  }

  function MyButton(props) {
    return <button {...props} />
  }
  const addInputField = () => {
    setInputFields([...inputFields, {
      type: "ListItem",
      position: inputFields.length + 1,
      name: '',
      item: '',
    }])

  }
  const removeInputFields = (index) => {
    const rows = [...inputFields];
    rows.splice(index, 1);
    setInputFields(rows);
  }


  const onCopy = React.useCallback(() => {
    setCopied(true);
    setTimeout(function () {
      setCopied(false);
    }, 3000);
  }, [])
 
  const BreadcrumbIsMyCopy = `<script type="application/ld+json">
  {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": [`+
    inputFields.map((item, inde) =>
          `{
            "type":"ListItem",
            "position":`+parseInt(inde+1)+`,
            "name":"`+item.name+`",
            "item":"`+item.item+`"
          }`
      )

    + `]
  }
  </script><!--BreadcrumbList Code Generated by https://w3speedup.com/tools/schema-markup-generator/ -->`;

  const resetFun = () =>{
    const sws_rows = [{
      '@type': "ListItem",
      position: 1,
      name: '',
      item: '',
    }]; 
    setInputFields(sws_rows);
  }
  return (
    <div className='row mt-5 breadcrumb_row'>
      <div className='col-md-8 mb-5 border'>
        <div className='mb-4 breadcrumb_row_title'><h2>Form for generate JSON-LD Schema Markup</h2></div>
      <p>Use the following JSON-LD schema generator to generate the markup code for the breadcrumb list:</p>
      <small>Press <i className="fa-solid fa-plus"></i> to add another page</small>
        <div className='mt-2 d-flex breadcrumb_header'>
          <div className='col-5'>
          <b>Page name</b>
          </div>
          <div className='col-5'>
          <b>URL</b>
          </div>
          <div className='col-2 justify-content-center'>
          
          </div>
        </div>
        { 
          inputFields.map((data, index) => {
            const { name, item } = data; 
            return (
              <div className="input_fields d-flex" key={index}>
                <div className="col-5 d-block">
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange1(index, evnt)} value={data.name} name="name" className="form-control" placeholder="Page" />
                  </div>
                </div>
                <div className="col-5 d-block">
                  <div className="form-group me-2 mb-2">
                    <input type="url" onChange={(evnt) => handleChange1(index, evnt)} value={data.item} name="item" className="form-control" placeholder="URL" />
                  </div>
                  {isTrueVal[1] && (isTrueVal[0]=== index && item.length > 0) &&  (
                    <div style={{ color: "#F61C04" }}>URL is not valid.</div>
                  )}
                </div>
                <div className="col-2 justify-content-center">
                  {(inputFields.length !== 1) ? <button className="btn btn-outline-danger dltbtn" onClick={()=>removeInputFields(index)}><i className="fa-solid fa-minus"></i></button> : ''}
                </div>
              </div>
            )
          })
        }
        <div className="col mt-3 mb-3">
          {/* <button className="btn btn-outline-success " onClick={addInputField}>Add New</button> */}
          <b><button className="btn btn-outline-success addbtn" onClick={addInputField}><i className="fa-solid fa-plus"></i></button></b>
        </div>
      </div>
      <div className='col-md-4'>
        <div className="card">
          <div className="card-header d-flex">
            <CopyToClipboard onCopy={onCopy} text={BreadcrumbIsMyCopy} >
              <MyButton className="btn btn-success"><i className="fa-solid fa-copy me-2"></i>Copy</MyButton>
            </CopyToClipboard>
            <MyButton className="btn btn-success" onClick={()=>resetFun()}><i className="fa-solid fa-arrows-rotate me-1"></i>Reset</MyButton>
          </div>
          <div className="card-body">
            {BreadcrumbIsMyCopy}
          </div>
          {copied &&
            <div className="card-footer text-muted">
              <div className="p-2 btn-success rounded">✅ copied successfully</div>
            </div>
          }
        </div>
      </div>
    </div>
  );
}

export default Breadcrumb